export enum NotificationType
{
    eventCreated = "event_created",
    eventEdited = "event_edited",
    eventDeleted = "event_deleted",
    eventCommented = "event_commented"
}